module.exports = Object.freeze({
  'C# - HttpClient': `var client = new HttpClient();
var request = new HttpRequestMessage(HttpMethod.Get, "https://api.grufity.com/stock/getallmetrics?ticker=AAPL");
request.Headers.Add("X-API-KEY", "<Please Replace this with your API Key>");
var response = await client.SendAsync(request);
response.EnsureSuccessStatusCode();
Console.WriteLine(await response.Content.ReadAsStringAsync());
`,
  'C# - RestSharp': `var options = new RestClientOptions("https://api.grufity.com")
{
  MaxTimeout = -1,
};
var client = new RestClient(options);
var request = new RestRequest("/stock/getallmetrics?ticker=AAPL", Method.Get);
request.AddHeader("X-API-KEY", "<Please Replace this with your API Key>");
RestResponse response = await client.ExecuteAsync(request);
Console.WriteLine(response.Content);`,
  'cURL': `curl --location 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL' \
--header 'X-API-KEY: <Please Replace this with your API Key>'`,
  'Dart - http': `var headers = {
  'X-API-KEY': '<Please Replace this with your API Key>'
};
var request = http.Request('GET', Uri.parse('https://api.grufity.com/stock/getallmetrics?ticker=AAPL'));

request.headers.addAll(headers);

http.StreamedResponse response = await request.send();

if (response.statusCode == 200) {
  print(await response.stream.bytesToString());
}
else {
  print(response.reasonPhrase);
}
`,
  'Go - Native': `package main

import (
  "fmt"
  "net/http"
  "io/ioutil"
)

func main() {

  url := "https://api.grufity.com/stock/getallmetrics?ticker=AAPL"
  method := "GET"

  client := &http.Client {
  }
  req, err := http.NewRequest(method, url, nil)

  if err != nil {
    fmt.Println(err)
    return
  }
  req.Header.Add("X-API-KEY", "<Please Replace this with your API Key>")

  res, err := client.Do(req)
  if err != nil {
    fmt.Println(err)
    return
  }
  defer res.Body.Close()

  body, err := ioutil.ReadAll(res.Body)
  if err != nil {
    fmt.Println(err)
    return
  }
  fmt.Println(string(body))
}`,
  'HTTP - HTTP': `GET /stock/getallmetrics?ticker=AAPL HTTP/1.1
Host: api.grufity.com
X-API-KEY: <Please Replace this with your API Key>`,
  'Java - OkHttp': `OkHttpClient client = new OkHttpClient().newBuilder()
  .build();
MediaType mediaType = MediaType.parse("text/plain");
RequestBody body = RequestBody.create(mediaType, "");
Request request = new Request.Builder()
  .url("https://api.grufity.com/stock/getallmetrics?ticker=AAPL")
  .method("GET", body)
  .addHeader("X-API-KEY", "<Please Replace this with your API Key>")
  .build();
Response response = client.newCall(request).execute();`,
  'Java - Unirest': `Unirest.setTimeouts(0, 0);
HttpResponse<String> response = Unirest.get("https://api.grufity.com/stock/getallmetrics?ticker=AAPL")
  .header("X-API-KEY", "<Please Replace this with your API Key>")
  .asString();
`,
  'JavaScript - Fetch': `var myHeaders = new Headers();
myHeaders.append("X-API-KEY", "<Please Replace this with your API Key>");

var requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow'
};

fetch("https://api.grufity.com/stock/getallmetrics?ticker=AAPL", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));`,
  'JavaScript - jQuery': `var settings = {
  "url": "https://api.grufity.com/stock/getallmetrics?ticker=AAPL",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "X-API-KEY": "<Please Replace this with your API Key>"
  },
};

$.ajax(settings).done(function (response) {
  console.log(response);
});`,
  'JavaScript - XHR': `// WARNING: For GET requests, body is set to null by browsers.

var xhr = new XMLHttpRequest();
xhr.withCredentials = true;

xhr.addEventListener("readystatechange", function() {
  if(this.readyState === 4) {
    console.log(this.responseText);
  }
});

xhr.open("GET", "https://api.grufity.com/stock/getallmetrics?ticker=AAPL");
xhr.setRequestHeader("X-API-KEY", "<Please Replace this with your API Key>");

xhr.send();`,
  'C - libcurl': `CURL *curl;
CURLcode res;
curl = curl_easy_init();
if(curl) {
  curl_easy_setopt(curl, CURLOPT_CUSTOMREQUEST, "GET");
  curl_easy_setopt(curl, CURLOPT_URL, "https://api.grufity.com/stock/getallmetrics?ticker=AAPL");
  curl_easy_setopt(curl, CURLOPT_FOLLOWLOCATION, 1L);
  curl_easy_setopt(curl, CURLOPT_DEFAULT_PROTOCOL, "https");
  struct curl_slist *headers = NULL;
  headers = curl_slist_append(headers, "X-API-KEY: <Please Replace this with your API Key>");
  curl_easy_setopt(curl, CURLOPT_HTTPHEADER, headers);
  res = curl_easy_perform(curl);
}
curl_easy_cleanup(curl);
`,
  'NodeJs - Axios': `var axios = require('axios');

var config = {
  method: 'get',
maxBodyLength: Infinity,
  url: 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL',
  headers: {
    'X-API-KEY': '<Please Replace this with your API Key>'
  }
};

axios(config)
.then(function (response) {
  console.log(JSON.stringify(response.data));
})
.catch(function (error) {
  console.log(error);
});
`,
  'NodeJs - Native': `var https = require('follow-redirects').https;
var fs = require('fs');

var options = {
  'method': 'GET',
  'hostname': 'api.grufity.com',
  'path': '/stock/getallmetrics?ticker=AAPL',
  'headers': {
    'X-API-KEY': '<Please Replace this with your API Key>'
  },
  'maxRedirects': 20
};

var req = https.request(options, function (res) {
  var chunks = [];

  res.on("data", function (chunk) {
    chunks.push(chunk);
  });

  res.on("end", function (chunk) {
    var body = Buffer.concat(chunks);
    console.log(body.toString());
  });

  res.on("error", function (error) {
    console.error(error);
  });
});

req.end();`,
  'NodeJs - Request': `var request = require('request');
var options = {
  'method': 'GET',
  'url': 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL',
  'headers': {
    'X-API-KEY': '<Please Replace this with your API Key>'
  }
};
request(options, function (error, response) {
  if (error) throw new Error(error);
  console.log(response.body);
});
`,
  'NodeJs - Unirest': `var unirest = require('unirest');
var req = unirest('GET', 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL')
  .headers({
    'X-API-KEY': '<Please Replace this with your API Key>'
  })
  .end(function (res) {
    if (res.error) throw new Error(res.error);
    console.log(res.raw_body);
  });
`,
  'Objective-C - NSURLSession': `#import <Foundation/Foundation.h>

dispatch_semaphore_t sema = dispatch_semaphore_create(0);

NSMutableURLRequest *request = [NSMutableURLRequest requestWithURL:[NSURL URLWithString:@"https://api.grufity.com/stock/getallmetrics?ticker=AAPL"]
  cachePolicy:NSURLRequestUseProtocolCachePolicy
  timeoutInterval:10.0];
NSDictionary *headers = @{
  @"X-API-KEY": @"<Please Replace this with your API Key>"
};

[request setAllHTTPHeaderFields:headers];

[request setHTTPMethod:@"GET"];

NSURLSession *session = [NSURLSession sharedSession];
NSURLSessionDataTask *dataTask = [session dataTaskWithRequest:request
completionHandler:^(NSData *data, NSURLResponse *response, NSError *error) {
  if (error) {
    NSLog(@"%@", error);
    dispatch_semaphore_signal(sema);
  } else {
    NSHTTPURLResponse *httpResponse = (NSHTTPURLResponse *) response;
    NSError *parseError = nil;
    NSDictionary *responseDictionary = [NSJSONSerialization JSONObjectWithData:data options:0 error:&parseError];
    NSLog(@"%@",responseDictionary);
    dispatch_semaphore_signal(sema);
  }
}];
[dataTask resume];
dispatch_semaphore_wait(sema, DISPATCH_TIME_FOREVER);`,
  'OCaml - Cohttp': `open Lwt
open Cohttp
open Cohttp_lwt_unix

let reqBody =
  let uri = Uri.of_string "https://api.grufity.com/stock/getallmetrics?ticker=AAPL" in
  let headers = Header.init ()
    |> fun h -> Header.add h "X-API-KEY" "<Please Replace this with your API Key>"
  in
  Client.call ~headers \`GET uri >>= fun(_resp, body) ->
  body |> Cohttp_lwt.Body.to_string >|= fun body -> body

let() =
  let respBody = Lwt_main.run reqBody in
  print_endline(respBody)`,
  'PHP - cURL': `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'GET',
  CURLOPT_HTTPHEADER => array(
    'X-API-KEY: <Please Replace this with your API Key>'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
`,
  'PHP - Guzzle': `<?php
$client = new Client();
$headers = [
  'X-API-KEY' => '<Please Replace this with your API Key>'
];
$request = new Request('GET', 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL', $headers);
$res = $client->sendAsync($request)->wait();
echo $res->getBody();
`,
  'PHP - HTTP_Request2': `<?php
require_once 'HTTP/Request2.php';
$request = new HTTP_Request2();
$request->setUrl('https://api.grufity.com/stock/getallmetrics?ticker=AAPL');
$request->setMethod(HTTP_Request2::METHOD_GET);
$request->setConfig(array(
  'follow_redirects' => TRUE
));
$request->setHeader(array(
  'X-API-KEY' => '<Please Replace this with your API Key>'
));
try {
  $response = $request->send();
  if ($response->getStatus() == 200) {
    echo $response->getBody();
  }
  else {
    echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
    $response->getReasonPhrase();
  }
}
catch(HTTP_Request2_Exception $e) {
  echo 'Error: ' . $e->getMessage();
}`,
  'PHP - pecl_http': `<?php
$client = new http\\Client;
$request = new http\\Client\\Request;
$request->setRequestUrl('https://api.grufity.com/stock/getallmetrics?ticker=AAPL');
$request->setRequestMethod('GET');
$request->setOptions(array());
$request->setHeaders(array(
  'X-API-KEY' => '<Please Replace this with your API Key>'
));
$client->enqueue($request)->send();
$response = $client->getResponse();
echo $response->getBody();
`,
  'PowerShell - RestMethod': `$headers = New-Object "System.Collections.Generic.Dictionary[[String],[String]]"
$headers.Add("X-API-KEY", "<Please Replace this with your API Key>")

$response = Invoke-RestMethod 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL' -Method 'GET' -Headers $headers
$response | ConvertTo-Json`,
  'Python - http.client': `import http.client

conn = http.client.HTTPSConnection("api.grufity.com")
payload = ''
headers = {
  'X-API-KEY': '<Please Replace this with your API Key>'
}
conn.request("GET", "/stock/getallmetrics?ticker=AAPL", payload, headers)
res = conn.getresponse()
data = res.read()
print(data.decode("utf-8"))`,
  'Python - Requests': `import requests

url = "https://api.grufity.com/stock/getallmetrics?ticker=AAPL"

payload={}
headers = {
  'X-API-KEY': '<Please Replace this with your API Key>'
}

response = requests.request("GET", url, headers=headers, data=payload)

print(response.text)
`,
  'R - httr': `library(httr)

headers = c(
  'X-API-KEY' = '<Please Replace this with your API Key>'
)

res <- VERB("GET", url = "https://api.grufity.com/stock/getallmetrics?ticker=AAPL", add_headers(headers))

cat(content(res, 'text'))`,
  'R - RCurl': `library(RCurl)
headers = c(
  "X-API-KEY" = "<Please Replace this with your API Key>"
)
res <- getURL("https://api.grufity.com/stock/getallmetrics?ticker=AAPL", .opts=list(httpheader = headers, followlocation = TRUE))
cat(res)`,
  'Ruby - Net::HTTP': `require "uri"
require "net/http"

url = URI("https://api.grufity.com/stock/getallmetrics?ticker=AAPL")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::Get.new(url)
request["X-API-KEY"] = "<Please Replace this with your API Key>"

response = https.request(request)
puts response.read_body
`,
  'Shell - Httpie': `http --follow --timeout 3600 GET 'https://api.grufity.com/stock/getallmetrics?ticker=AAPL' \\
 X-API-KEY:'<Please Replace this with your API Key>'`,
  'Shell - wget': `wget --no-check-certificate --quiet \\
  --method GET \\
  --timeout=0 \\
  --header 'X-API-KEY: <Please Replace this with your API Key>' \\
   'https://api.grufity.com/stock/getallmetrics?ticker=AAPL'`,
  'Swift - URLSession': `var request = URLRequest(url: URL(string: "https://api.grufity.com/stock/getallmetrics?ticker=AAPL")!,timeoutInterval: Double.infinity)
request.addValue("<Please Replace this with your API Key>", forHTTPHeaderField: "X-API-KEY")

request.httpMethod = "GET"

let task = URLSession.shared.dataTask(with: request) { data, response, error in
  guard let data = data else {
    print(String(describing: error))
    return
  }
  print(String(data: data, encoding: .utf8)!)
}

task.resume()
`,
});
